<template>
  <component ref="cpt" v-if="cpt_name" :is="cpt_name" @close="close"/>
</template>

<script>
import EventBus from '@/common/EventBus'
import RoomSettings from './room-settings/index.vue'
import ChannelSettings from './channel-settings/index.vue';

export default {
  data() {
    return {
      cpt_name: '',
    }
  },
  components: {
    RoomSettings,
    ChannelSettings,
  },
  mounted() {
    EventBus.$on('show-dynamic-component', this.initCpt)
  },
  beforeDestroy() {
    EventBus.$off('show-dynamic-component', this.initCpt)
  },
  methods: {
    initCpt (name = '', data = {}, ...args) {
      if (data === false) {
        this.cpt_name = ''
        return
      }
      this.cpt_name = name
      this.$nextTick(() => {
        this.$refs.cpt?.init(data, ...args)
      })
    },
    close () {
      this.cpt_name = ''
    }
  }
}
</script>